import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_12W_79_12W_19_99',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_12w_79_12w_19_99_usd',
			EUR: 'simple_premium_12w_69_12w_19_99_eur',
			GBP: 'simple_premium_12w_79_12w_19_99_gbp',
			AUD: 'simple_premium_12w_129_12w_29_99_aud',
			CAD: 'simple_premium_12w_129_12w_29_99_cad',
			DKK: 'simple_premium_12w_599_12w_149_dkk',
			SEK: 'simple_premium_12w_920_12w_229_sek',
			NOK: 'simple_premium_12w_920_12w_229_nok',
			MXN: 'simple_premium_12w_1299_12w_329_mxn',
			BRL: 'simple_premium_12w_179_12w_69_brl',
			TRY: 'simple_premium_12w_2599_12w_666_try',
			ARS: 'simple_premium_12w_104990_12w_26990_ars',
			COP: 'simple_premium_12w_319990_12w_80990_cop',
			CLP: 'simple_premium_12w_75990_12w_19990_clp',
		},
		primer: 'prd_88fIPQK7k7jA',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 12,
		intro_period_type: 'week',
		next_period_value: 12,
		next_period_type: 'week',
	},
	trial: {
		days: 84,
		priceMap: {
			USD: 19.99,
			EUR: 19.99,
			GBP: 19.99,
			AUD: 29.99,
			CAD: 29.99,
			DKK: 149,
			SEK: 229,
			NOK: 229,
			MXN: 329,
			BRL: 69,
			TRY: 666,
			ARS: 26990,
			COP: 80990,
			CLP: 19990,
		},
		originalPriceMap: {
			USD: 79,
			EUR: 69,
			GBP: 79,
			AUD: 129,
			CAD: 129,
			DKK: 599,
			SEK: 920,
			NOK: 920,
			MXN: 1299,
			BRL: 179,
			TRY: 2599,
			ARS: 104990,
			COP: 319990,
			CLP: 75990,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 3,
		priceMap: {
			USD: 79,
			EUR: 69,
			GBP: 79,
			AUD: 129,
			CAD: 129,
			DKK: 599,
			SEK: 920,
			NOK: 920,
			MXN: 1299,
			BRL: 179,
			TRY: 2599,
			ARS: 104990,
			COP: 319990,
			CLP: 75990,
		},
	},
	options: ($t, product, $tc) => ({
		explicitTermsPeriodText: $t('pages.program.organic.cheap_and_short.plans.90_days.into_period_text'), // 'first quarter'
		explicitTermsIntervalText: $t('pages.program.organic.cheap_and_short.plans.90_days.sub_period_text'), // 'quarterly'
		billingSubtitlePeriodText: $t('pages.program.cheap_and_short.plans.90_days.into_period_text'), // 'three months'
		footerPeriodText: $tc('common.duration.week.dashed.lowercase', 12), // '3-month'
		footerIntervalText: $t('pages.program.cheap_and_short.plans.90_days.sub_period_text'), // '3-month'
	}),
}
